import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PropertiesService, RealProperty } from '@eemo/api-client';
import { AuthenticationService } from '@/services/authentication.service';
import { UserRightsService } from '@/services/user-rights.service';
import { UntypedFormBuilder, Validators, AbstractControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export class PropertyRoomDialogData {
  ownerOnly = true;
  updateRightsOnly = false;
  targetUserId: string = null;
}

@Component({
    selector: 'app-property-select-dialog',
    templateUrl: './property-select-dialog.component.html',
    styleUrls: ['./property-select-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, NgIf, MatButtonModule]
})
export class PropertySelectDialogComponent implements OnInit {
  props: RealProperty[];
  propSelectForm: UntypedFormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyRoomDialogData,
    private fb: UntypedFormBuilder,
    private propertyService: PropertiesService,
    private authenticationService: AuthenticationService,
    private rightService: UserRightsService,
    public dialogRef: MatDialogRef<PropertySelectDialogComponent>
  ) {}

  ngOnInit() {
    this.propSelectForm = this.fb.group({
      propertyId: ['', [Validators.required]]
    });

    this.props = [];
    this.propertyService.getRealPropertyList().subscribe((props) => {
      // TODO manage pagination
      props.list
        .filter(
          (prop) =>
            (this.data.ownerOnly && prop.owner.uid === this.authenticationService.currentUserValue.userId) ||
            !this.data.ownerOnly
        )
        .filter(
          (prop) =>
            (this.data.updateRightsOnly && this.rightService.hasUpdateRightOnProperty(prop.uid)) ||
            !this.data.updateRightsOnly
        )
        .filter(
          (prop) => (this.data.targetUserId && prop.owner.uid === this.data.targetUserId) || !this.data.targetUserId
        )
        .forEach((prop) => this.props.push(prop));
      if (props.list.length > 0) {
        this.f('propertyId').setValue(props[0].uid);
      }
    });
  }

  f(field: string): AbstractControl {
    return this.propSelectForm.get(field);
  }

  onSubmit() {
    if (this.propSelectForm.valid) {
      this.dialogRef.close(this.props.find((prop) => prop.uid === this.f('propertyId').value));
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
